module.exports = __webpack_public_path__ + "img/9788959522682.ae8b89d2.jpg";